import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./globalReducer";
import offerReducer from "./offerReducer";
import transactionReducer from "./transactionReducer";

export const store = configureStore({
  reducer: {
    global: globalReducer,
    trans: transactionReducer,
    offer: offerReducer,
  }
});
